export default {
  noAddress: "Nessun indirizzo",
  title: "Strutture",
  subtitle: "Tutte le strutture della piattaforma",
  searchPlaceholder: "Cerca per struttura o proprietario...",
  loadError: "Impossibile caricare le strutture",
  retry: "Riprova",
  empty: "Nessuna struttura corrisponde ai filtri.",
  openRowAria: "Apri struttura {{name}}",
  filters: {
    status: "Stato",
    statusAll: "Tutte",
    statusActive: "Attive",
    statusInactive: "Inattive",
  },
  columns: {
    name: "Struttura",
    owner: "Proprietario",
    commission: "Commissione",
  },
} as const;
